module.exports = __webpack_public_path__ + "static/image 120-2c6ebbffe53000a23a994ec2ea83cbf5.jpg";